// Shared TextField styling for inputs that sit on the app's DARK dialog surfaces.
//
// MUI's default outlined field takes its focus ring and floating-label colour from
// palette.primary, which in this theme is a mid blue. On a dark dialog that blue is close
// to invisible — so the label and the focus ring both disappear at the exact moment the
// user clicks in, which is when they most need to see where they are typing.
//
// Neutral light rather than red, even in destructive dialogs: a red ring on an input reads
// as "this value is invalid", and an empty confirmation field is not invalid.
//
// Written once because the type-to-confirm dialogs (delete account, delete organization,
// delete scenario) each hand-rolled their own partial version, and the ones that only set
// a resting border still fell back to theme blue on focus.
export const darkFieldSx = {
  "& .MuiInputLabel-root": { color: "rgba(233, 238, 255, 0.78)" },
  "& .MuiInputLabel-root.Mui-focused": { color: "#ffffff" },
  "& .MuiInputLabel-root.Mui-disabled": { color: "rgba(233, 238, 255, 0.4)" },
  "& .MuiOutlinedInput-root": {
    color: "#f8fbff",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.32)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.55)",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ffffff",
      borderWidth: 2,
    },
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.16)",
    },
  },
  // Helper text is often the only place a mismatch is reported, so it must not be dim.
  "& .MuiFormHelperText-root": { color: "rgba(233, 238, 255, 0.7)" },
};

export default darkFieldSx;
